import { render } from "./LanguageMulti.vue?vue&type=template&id=32f998ff"
import script from "./LanguageMulti.vue?vue&type=script&lang=js"
export * from "./LanguageMulti.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__